/**
 * Created by ianandersen on 4/6/17.
 */

import React from 'react';
import Description from './FileProperties/Description';
import Download from './FileProperties/Download';
import RelatedFiles from './FileProperties/RelatedFiles';
import Series from './FileProperties/Series';
import Subtitle from './FileProperties/Subtitle';
import Tags from './FileProperties/Tags';
import Title from './FileProperties/Title';
import Author from './FileProperties/Author';
import ShareButtons from 'Views/ShareButtons';
import moment from 'moment';
import VideoFileGlobalPlayer from '../../Components/Video/VideoFileGlobalPlayer';

class VideoView extends React.Component{
  constructor(props){
    super(props);
    this.file = props.file;
  }

  render(){
    let file = this.file;
    return (
      <div className="container clearfix" style={{height: '100%', width: '100%', padding: '0'}}>
        <div style={{padding: '50px 10px', height: file.get('location') === 'facebook' || file.get('location') === 'youtube' ? null : '600px', width: '100%', background: 'url(../images/patterns/45-degree-fabric-light.png) #111', textAlign: 'center'}}>
          {file.get("visibility") === 'private' && !this.props.userOwned ? null : <VideoFileGlobalPlayer file={file} />}
        </div>
        <div className={'clearfix'} style={{
          paddingLeft: '15px',
          paddingRight: '15px',
          paddingTop: '20px',
          paddingBottom: '50px',
          textAlign: 'center'
        }}>
          <div className="col-md-12">
            <a href="#" onClick={(e) => {e.preventDefault(); window.history.back();}} className="file-back-button">
              <h3 style={{cursor: 'pointer', fontSize: 20, textAlign: 'left'}}>
                <i className="fa fa-arrow-left"></i> Back
              </h3>
            </a>
            <Title text={file.get('title')} />
            <Subtitle text={file.get('subtitle')}/>
            <h4 style={{color: '#777'}}>{moment(file.get('display_date')).format('LL')}</h4>
            <Author text={file.get('author')}/>
            <Description style={{marginTop: '10px'}} text={file.get('description')}/>
            {file.isDownloadable() ? <Download file={file} name={file.get('title') + '.' + file.get('extension')} url={file.downloadLink}/> : null}
            <RelatedFiles files={file.get('related_files')}/>
            <Series series={file.get('media_series')}/>
            <Tags file={file}/>
            {this.props.social.url ? <ShareButtons {...this.props.social}/> :
              <ShareButtons {...this.props.social} url={window.location.href}/>}
          </div>
        </div>
      </div>
    );
  }
}

export default VideoView;
